export default "__VITE_ASSET__CnzXo_EV__"